export const Diseases = {
  "Hypertensive disease": [
    "Pain chest",
    "Shortness of breath",
    "Dizziness",
    "Asthenia",
    "Fall",
    "Syncope",
    "Vertigo",
    "Sweat",
    "Sweating increased",
    "Palpitation",
    "Nausea",
    "Angina pectoris",
    "Pressure chest",
  ],
  "Coronavirus disease 2019": ["Fever", "Dry cough", "Fatigue", "Pain", "Throat sore", "Diarrhea", "Headache", "Loss of taste or smell", "Out of breath", "Pain chest", "Pressure chest"],
  Diabetes: [
    "Polyuria",
    "Polydypsia",
    "Shortness of breath",
    "Pain chest",
    "Asthenia",
    "Nausea",
    "Orthopnea",
    "Rale",
    "Sweat",
    "Sweating increased",
    "Unresponsiveness",
    "Mental status changes",
    "Vertigo",
    "Vomiting",
    "Labored breathing",
  ],
  "Depression mental": [
    "Feeling suicidal",
    "Suicidal",
    "Hallucinations auditory",
    "Feeling hopeless",
    "Weepiness",
    "Sleeplessness",
    "Motor retardation",
    "Irritable mood",
    "Blackout",
    "Mood depressed",
    "Hallucinations visual",
    "Worry",
    "Agitation",
    "Tremor",
    "Intoxication",
    "Verbal auditory hallucinations",
    "Energy increased",
    "Difficulty",
    "Nightmare",
    "Unable to concentrate",
    "Homelessness",
  ],
  "Depressive disorder": [
    "Feeling suicidal",
    "Suicidal",
    "Hallucinations auditory",
    "Feeling hopeless",
    "Weepiness",
    "Sleeplessness",
    "Motor retardation",
    "Irritable mood",
    "Blackout",
    "Mood depressed",
    "Hallucinations visual",
    "Worry",
    "Agitation",
    "Tremor",
    "Intoxication",
    "Verbal auditory hallucinations",
    "Energy increased",
    "Difficulty",
    "Nightmare",
    "Unable to concentrate",
    "Homelessness",
  ],
  "Coronary arteriosclerosis": [
    "Pain chest",
    "Angina pectoris",
    "Shortness of breath",
    "Hypokinesia",
    "Sweat",
    "Sweating increased",
    "Pressure chest",
    "Dyspnea on exertion",
    "Orthopnea",
    "Chest tightness",
  ],
  "Coronary heart disease": [
    "Pain chest",
    "Angina pectoris",
    "Shortness of breath",
    "Hypokinesia",
    "Sweat",
    "Sweating increased",
    "Pressure chest",
    "Dyspnea on exertion",
    "Orthopnea",
    "Chest tightness",
  ],
  Pneumonia: [
    "Cough",
    "Fever",
    "Decreased translucency",
    "Shortness of breath",
    "Rale",
    "Productive cough",
    "Pleuritic pain",
    "Yellow sputum",
    "Breath sounds decreased",
    "Chill",
    "Rhonchus",
    "Green sputum",
    "Non-productive cough",
    "Wheezing",
    "Haemoptysis",
    "Distress respiratory",
    "Tachypnea",
    "Malaise",
    "Night sweat",
  ],
  "Failure heart congestive": ["Shortness of breath", "Orthopnea", "Jugular venous distention", "Rale", "Dyspnea", "Cough", "Wheezing"],
  "Accident\u00a0cerebrovascular": ["Dysarthria", "Asthenia", "Speech slurred", "Facial paresis", "Hemiplegia", "Unresponsiveness", "Seizure", "Numbness"],
  Asthma: ["Wheezing", "Cough", "Shortness of breath", "Chest tightness", "Non-productive cough", "Pleuritic pain", "Productive cough", "Symptom aggravating factors", "Distress respiratory"],
  "Myocardial infarction": [
    "Pain chest",
    "St segment elevation",
    "Sweat",
    "Sweating increased",
    "Shortness of breath",
    "St segment depression",
    "Hypokinesia",
    "Angina pectoris",
    "Pressure chest",
    "T wave inverted",
    "Orthopnea",
    "Rale",
    "Chest tightness",
    "Presence of q wave",
    "Palpitation",
    "Dyspnea",
    "Chest discomfort",
    "Bradycardia",
    "Syncope",
  ],
  Hypercholesterolemia: [
    "Pain",
    "Pain chest",
    "Sweat",
    "Sweating increased",
    "Nonsmoker",
    "Pressure chest",
    "Syncope",
    "Numbness",
    "Chest discomfort",
    "Shortness of breath",
    "St segment depression",
    "Worry",
    "T wave inverted",
    "Bradycardia",
    "Dyspnea",
  ],
  Infection: ["Fever", "Erythema", "Decreased translucency", "Hepatosplenomegaly", "Chill", "Pruritus", "Diarrhea", "Abscess bacterial", "Swelling", "Pain", "Apyrexial", "Cough"],
  "Infection urinary tract": [
    "Fever",
    "Dysuria",
    "Hematuria",
    "Renal angle tenderness",
    "Lethargy",
    "Asthenia",
    "Hyponatremia",
    "Hemodynamically stable",
    "Distress respiratory",
    "Difficulty passing urine",
    "Mental status changes",
    "Consciousness clear",
  ],
  Anemia: [
    "Chill",
    "Guaiac positive",
    "Monoclonal",
    "Ecchymosis",
    "Tumor cell invasion",
    "Haemorrhage",
    "Pallor",
    "Asthenia",
    "Fatigue",
    "Heme positive",
    "Pain back",
    "Orthostasis",
    "Hyponatremia",
    "Dizziness",
    "Shortness of breath",
    "Pain",
    "Rhonchus",
    "Arthralgia",
    "Swelling",
    "Transaminitis",
  ],
  "Chronic obstructive airway disease": [
    "Shortness of breath",
    "Wheezing",
    "Cough",
    "Dyspnea",
    "Distress respiratory",
    "Sputum purulent",
    "Hypoxemia",
    "Hypercapnia",
    "Patient non compliance",
    "Chest tightness",
  ],
  Dementia: [
    "Fever",
    "Fall",
    "Unresponsiveness",
    "Lethargy",
    "Agitation",
    "Ecchymosis",
    "Syncope",
    "Rale",
    "Unconscious state",
    "Cough",
    "Bedridden",
    "Bedridden",
    "Pain",
    "Facial paresis",
    "Abdominal tenderness",
    "Rhonchus",
    "Unsteady gait",
    "Hallucinations auditory",
  ],
  "Insufficiency renal": [
    "Shortness of breath",
    "Hyperkalemia",
    "Orthopnea",
    "Rale",
    "Urgency of\u00a0micturition",
    "Ascites",
    "Guaiac positive",
    "Asthenia",
    "Apyrexial",
    "Mental status changes",
    "Dyspnea",
    "Difficulty",
    "Diarrhea",
    "Hypotension",
    "Breath sounds decreased",
    "Swelling",
    "Hypokinesia",
  ],
  Confusion: [
    "Seizure",
    "Enuresis",
    "Lethargy",
    "Speech slurred",
    "Fall",
    "Consciousness clear",
    "Mental status changes",
    "Asterixis",
    "Unconscious state",
    "Agitation",
    "Muscle twitch",
    "Asthenia",
    "Sleepy",
    "Dizziness",
    "Headache",
    "Dysarthria",
    "Lightheadedness",
    "Tremor",
    "Hyponatremia",
    "Unresponsiveness",
  ],
  "Degenerative\u00a0polyarthritis": [
    "Pain",
    "Food intolerance",
    "Numbness of hand",
    "General discomfort",
    "Drowsiness",
    "Asthenia",
    "Nonsmoker",
    "Non-productive cough",
    "Polydypsia",
    "Stiffness",
    "Unsteady gait",
  ],
  Hypothyroidism: [
    "Shortness of breath",
    "Prostatism",
    "Drowsiness",
    "Sleepy",
    "Hyponatremia",
    "Fall",
    "Unsteady gait",
    "Polyuria",
    "Hypotension",
    "Difficulty",
    "Syncope",
    "Nightmare",
    "Speech slurred",
    "Weight gain",
    "Asthenia",
    "Fatigue",
    "Agitation",
    "Mental status changes",
    "Motor retardation",
    "Vomiting",
    "Numbness",
    "Mass of body structure",
  ],
  "Anxiety state": [
    "Worry",
    "Feeling suicidal",
    "Suicidal",
    "Sleeplessness",
    "Feeling hopeless",
    "Irritable mood",
    "Tremor",
    "Blackout",
    "Weepiness",
    "Has religious belief",
    "Nervousness",
    "Hallucinations visual",
    "Formication",
    "Difficulty",
    "Pain chest",
    "Patient non compliance",
    "Agitation",
    "Palpitation",
    "Hallucinations auditory",
    "Mood depressed",
    "Hot flush",
    "Pain",
    "Consciousness clear",
    "Nightmare",
  ],
  "Malignant neoplasms": [
    "Pain",
    "Mass of body structure",
    "Lesion",
    "Cushingoid facies",
    "Cushingoid\u00a0habitus",
    "Emphysematous change",
    "Decreased body weight",
    "Ascites",
    "Hoarseness",
    "Thicken",
    "Hematuria",
  ],
  "Primary malignant neoplasm": [
    "Pain",
    "Mass of body structure",
    "Lesion",
    "Cushingoid facies",
    "Cushingoid\u00a0habitus",
    "Emphysematous change",
    "Decreased body weight",
    "Ascites",
    "Hoarseness",
    "Thicken",
    "Hematuria",
  ],
  "Acquired\u00a0immuno-deficiency syndrome": [
    "Fever",
    "Night sweat",
    "Spontaneous rupture of membranes",
    "Cough",
    "",
    "Decreased body weight",
    "Chill",
    "Diarrhea",
    "Pleuritic pain",
    "Patient non compliance",
    "Tachypnea",
    "Productive cough",
    "Muscle hypotonia",
    "Hypotonic",
    "Feeling suicidal",
  ],
  Hiv: [
    "Fever",
    "Night sweat",
    "Spontaneous rupture of membranes",
    "Cough",
    "",
    "Decreased body weight",
    "Chill",
    "Diarrhea",
    "Pleuritic pain",
    "Patient non compliance",
    "Tachypnea",
    "Productive cough",
    "Muscle hypotonia",
    "Hypotonic",
    "Feeling suicidal",
  ],
  "Hiv infections": [
    "Fever",
    "Night sweat",
    "Spontaneous rupture of membranes",
    "Cough",
    "",
    "Decreased body weight",
    "Chill",
    "Diarrhea",
    "Pleuritic pain",
    "Patient non compliance",
    "Tachypnea",
    "Productive cough",
    "Muscle hypotonia",
    "Hypotonic",
    "Feeling suicidal",
  ],
  Cellulitis: [
    "Erythema",
    "Pain",
    "Swelling",
    "Redness",
    "Fever",
    "Abscess bacterial",
    "Patient non compliance",
    "Hypesthesia",
    "Hyperacusis",
    "Pruritus",
    "Pain chest",
    "Scratch marks",
    "Chill",
    "Sore to touch",
  ],
  "Gastroesophageal reflux disease": [
    "Pain",
    "Pain chest",
    "Burning sensation",
    "Hyponatremia",
    "Satiety early",
    "Throbbing sensation quality",
    "Chest tightness",
    "Sensory discomfort",
    "Presence of q wave",
    "Nausea",
    "General discomfort",
    "Constipation",
    "Palpitation",
    "Pain abdominal",
    "Heartburn",
    "Sweat",
    "Sweating increased",
    "Asthenia",
  ],
  Septicemia: [
    "Fever",
    "Distress respiratory",
    "Hypotension",
    "Tachypnea",
    "Chill",
    "Lethargy",
    "Bradycardia",
    "Breech presentation",
    "Cyanosis",
    "Spontaneous rupture of membranes",
    "Haemorrhage",
    "Unresponsiveness",
    "Rale",
    "Apyrexial",
  ],
  "Systemic infection": [
    "Fever",
    "Distress respiratory",
    "Hypotension",
    "Tachypnea",
    "Chill",
    "Lethargy",
    "Bradycardia",
    "Breech presentation",
    "Cyanosis",
    "Spontaneous rupture of membranes",
    "Haemorrhage",
    "Unresponsiveness",
    "Rale",
    "Apyrexial",
  ],
  "Sepsis (invertebrate)": [
    "Fever",
    "Distress respiratory",
    "Hypotension",
    "Tachypnea",
    "Chill",
    "Lethargy",
    "Bradycardia",
    "Breech presentation",
    "Cyanosis",
    "Spontaneous rupture of membranes",
    "Haemorrhage",
    "Unresponsiveness",
    "Rale",
    "Apyrexial",
  ],
  "Deep vein thrombosis": [
    "Swelling",
    "Pain",
    "Ecchymosis",
    "Shortness of breath",
    "Pain in lower limb",
    "Cardiomegaly",
    "Rale",
    "Erythema",
    "Hypotension",
    "Clonus",
    "Non-productive cough",
    "Redness",
  ],
  Dehydration: [
    "Fever",
    "Diarrhea",
    "Vomiting",
    "Hypotension",
    "Nausea",
    "Lightheadedness",
    "Unwell",
    "Mental status changes",
    "Anorexia",
    "Asthenia",
    "Sensory discomfort",
    "Syncope",
    "Lethargy",
    "Dizziness",
    "Syncope",
    "Blackout",
    "History of - blackout",
  ],
  Neoplasm: [
    "Mass of body structure",
    "Lesion",
    "Pain chest",
    "Hematuria",
    "Tumor cell invasion",
    "Pain",
    "Anosmia",
    "Thicken",
    "Metastatic lesion",
    "Food intolerance",
    "Decreased body weight",
    "Night sweat",
    "Hemianopsia homonymous",
    "Satiety early",
    "Pain abdominal",
    "Headache",
  ],
  "Embolism pulmonary": [
    "Shortness of breath",
    "Hypoxemia",
    "Tachypnea",
    "Hematocrit decreased",
    "Pain chest",
    "Dyspnea",
    "Pleuritic pain",
    "Neck stiffness",
    "Yellow sputum",
    "Productive cough",
    "Cicatrisation",
    "Unresponsiveness",
    "Distress respiratory",
    "Wheezing",
    "Apyrexial",
    "Non-productive cough",
  ],
  Epilepsy: ["Seizure", "Hypometabolism", "Aura", "Muscle twitch", "Drowsiness", "Tremor", "Unresponsiveness", "Hemiplegia", "Myoclonus", "Gurgle", "Sleepy", "Lethargy", "Wheelchair bound"],
  Cardiomyopathy: [
    "Shortness of breath",
    "Orthopnea",
    "Hypokinesia",
    "Jugular venous distention",
    "Palpitation",
    "Pain chest",
    "Syncope",
    "Yellow sputum",
    "Rale",
    "Dyspnea",
    "Dyspnea on exertion",
    "Left\u00a0atrial\u00a0hypertrophy",
    "Fatigue",
    "Weight gain",
    "Patient non compliance",
  ],
  "Chronic kidney failure": [
    "Vomiting",
    "Orthopnea",
    "Hyperkalemia",
    "Oliguria",
    "Jugular venous distention",
    "Nausea",
    "Shortness of breath",
    "Mental status changes",
    "Diarrhea",
    "Asthenia",
    "Chest tightness",
    "Malaise",
    "Chill",
    "Rale",
    "Fever",
    "Pleuritic pain",
    "Apyrexial",
    "Guaiac positive",
    "Swelling",
    "Catatonia",
    "Unresponsiveness",
    "Yellow sputum",
  ],
  Carcinoma: [
    "Mass of body structure",
    "Pain",
    "Lesion",
    "Tumor cell invasion",
    "Thicken",
    "Decreased body weight",
    "Hoarseness",
    "General discomfort",
    "Metastatic lesion",
    "Non-productive cough",
    "Constipation",
    "Unhappy",
    "Paresthesia",
    "Gravida 0",
    "Diarrhea",
    "Sore to touch",
    "Heartburn",
    "Nausea",
    "Lung nodule",
  ],
  "Hepatitis c": ["Ascites", "Distended abdomen", "Feeling suicidal", "Cough", "Ache", "Macerated skin", "Heavy feeling", "Hallucinations auditory", "Chill", "Asterixis", "Patient non compliance"],
  "Peripheral vascular disease": [
    "Shortness of breath",
    "Rest pain",
    "Angina pectoris",
    "Unresponsiveness",
    "Hyperkalemia",
    "Sinus rhythm",
    "Labored breathing",
    "Dyspnea",
    "Sore to touch",
    "Anorexia",
    "Sleepy",
  ],
  "Psychotic disorder": [
    "Suicidal",
    "Hallucinations auditory",
    "Feeling suicidal",
    "Hallucinations visual",
    "Motor retardation",
    "Blackout",
    "Verbal auditory hallucinations",
    "Feeling hopeless",
    "Irritable mood",
    "Agitation",
    "Tremor",
    "Catatonia",
    "Weepiness",
    "Homelessness",
    "Sleeplessness",
    "Withdraw",
    "Energy increased",
    "Intoxication",
    "Worry",
    "Behavior hyperactive",
    "Patient non compliance",
    "Mood depressed",
    "Terrify",
    "Nightmare",
    "Consciousness clear",
  ],
  Hyperlipidemia: [
    "Pain chest",
    "Angina pectoris",
    "Palpitation",
    "Presence of q wave",
    "Photopsia",
    "Sweat",
    "Sweating increased",
    "Chest discomfort",
    "Shortness of breath",
    "Giddy mood",
    "Hypokinesia",
    "Hemiplegia",
    "Dizziness",
  ],
  "Bipolar disorder": [
    "Feeling suicidal",
    "Energy increased",
    "Suicidal",
    "Irritable mood",
    "Agitation",
    "Has religious belief",
    "Disturbed family",
    "Hallucinations auditory",
    "Verbal auditory hallucinations",
    "Weepiness",
    "Behavior hyperactive",
    "Catatonia",
    "Feeling hopeless",
    "Worry",
    "Sleeplessness",
    "Hypersomnia",
    "Difficulty",
    "Hallucinations visual",
    "Hyperhidrosis disorder",
    "Mydriasis",
    "Extrapyramidal sign",
    "Loose associations",
    "Intoxication",
    "Motor retardation",
    "Homelessness",
    "Blackout",
    "Tremor",
    "Exhaustion",
  ],
  Obesity: [
    "Pain",
    "Catatonia",
    "Snore",
    "Pain chest",
    "R wave feature",
    "Has religious belief",
    "Shortness of breath",
    "Fatigue",
    "Overweight",
    "Systolic murmur",
    "Mood depressed",
    "Ecchymosis",
  ],
  Ischemia: [
    "Drowsiness",
    "Sleepy",
    "Pain chest",
    "Angina pectoris",
    "Pressure chest",
    "Chest discomfort",
    "Shortness of breath",
    "Dyspnea",
    "Sinus rhythm",
    "Bradycardia",
    "Sweat",
    "Sweating increased",
    "Rale",
    "Asymptomatic",
    "Anorexia",
  ],
  Cirrhosis: [
    "Ascites",
    "Fall",
    "Splenomegaly",
    "Pruritus",
    "Pain abdominal",
    "Tumor cell invasion",
    "Distended abdomen",
    "Lesion",
    "Hemodynamically stable",
    "Guaiac positive",
    "Sore to touch",
    "Bleeding of vagina",
  ],
  Exanthema: ["Fever", "Pruritus", "Macule", "Lesion", "Redness", "Headache", "Apyrexial", "Arthralgia", "Swelling", "Erythema", "Photophobia", "Chill", "Scratch marks", "Pain", "Painful swallowing"],
  "Benign prostatic hypertrophy": ["Mental status changes", "Cachexia", "Blackout", "Orthostasis", "Orthopnea", "Night sweat", "Distress respiratory", "Anorexia", "Dysarthria"],
  "Kidney failure acute": [
    "Hyperkalemia",
    "Hypotension",
    "Hypocalcemia result",
    "Oliguria",
    "Hemodynamically stable",
    "Asthenia",
    "Hypothermia, natural",
    "Diarrhea",
    "Haemorrhage",
    "Unresponsiveness",
  ],
  "Mitral valve insufficiency": [
    "Shortness of breath",
    "Dyspnea on exertion",
    "Asymptomatic",
    "Hypokinesia",
    "Dyspnea",
    "Syncope",
    "Thicken",
    "Left\u00a0atrial\u00a0hypertrophy",
    "Palpitation",
    "Fatigue",
    "Vomiting",
    "Pain",
    "Cardiomegaly",
    "Chest discomfort",
  ],
  Arthritis: ["Pain", "Hemodynamically stable", "Sleeplessness", "Asthenia", "Syncope", "Swelling", "Atypia", "General unsteadiness", "Shortness of breath", "Distended abdomen"],
  Bronchitis: [
    "Cough",
    "Wheezing",
    "Shortness of breath",
    "Chest tightness",
    "Fever",
    "Throat sore",
    "Productive cough",
    "Hepatosplenomegaly",
    "Night sweat",
    "Haemoptysis",
    "Labored breathing",
    "Snuffle",
    "Hacking cough",
    "Dyspnea",
    "Chill",
    "Stridor",
    "Decreased body weight",
  ],
  Hemiparesis: [
    "Dysarthria",
    "Paresis",
    "Asthenia",
    "Aphagia",
    "Seizure",
    "Speech slurred",
    "Focal seizures",
    "Hemiplegia",
    "Abnormal sensation",
    "Unresponsiveness",
    "Stupor",
    "Drowsiness",
    "Sleepy",
    "Fremitus",
    "Stahli's line",
    "Stinging sensation",
    "Paralyse",
    "Clonus",
    "Facial paresis",
  ],
  Osteoporosis: [
    "Prostatism",
    "Fall",
    "Hirsutism",
    "Sniffle",
    "Distended abdomen",
    "Vertigo",
    "Numbness of hand",
    "Bradykinesia",
    "Pain",
    "Syncope",
    "Out of breath",
    "Apyrexial",
    "Urge incontinence",
    "Lightheadedness",
  ],
  "Transient ischemic attack": [
    "Speech slurred",
    "Dysarthria",
    "Facial paresis",
    "Asthenia",
    "Neck stiffness",
    "Vertigo",
    "Numbness",
    "Lightheadedness",
    "Extrapyramidal sign",
    "Stahli's line",
    "Vision blurred",
    "Headache",
    "Room spinning",
    "Syncope",
    "Difficulty",
    "Rambling speech",
    "Clumsiness",
  ],
  Adenocarcinoma: [
    "Mass of body structure",
    "Lesion",
    "Decreased body weight",
    "Constipation",
    "Fremitus",
    "Decreased stool caliber",
    "Satiety early",
    "Hematochezia",
    "Egophony",
    "Pain",
    "Cicatrisation",
    "Scar tissue",
    "Pain abdominal",
  ],
  Paranoia: [
    "Hallucinations auditory",
    "Hallucinations visual",
    "Agitation",
    "Irritable mood",
    "Verbal auditory hallucinations",
    "Feeling suicidal",
    "Suicidal",
    "Terrify",
    "Neologism",
    "Homelessness",
    "Energy increased",
    "Mood depressed",
    "Decompensation",
    "Cicatrisation",
    "Scar tissue",
    "Blackout",
    "Loose associations",
  ],
  Pancreatitis: ["Vomiting", "Pain abdominal", "Nausea", "Pain", "Diarrhea", "Stool color yellow", "Rigor - temperature-associated observation", "Apyrexial", "Sore to touch"],
  Incontinence: [
    "Paraparesis",
    "Seizure",
    "Asthenia",
    "Urge incontinence",
    "Unconscious state",
    "Aura",
    "Moody",
    "Fear of falling",
    "Tremor",
    "Spasm",
    "Unhappy",
    "Syncope",
    "Fall",
    "Stiffness",
    "Unresponsiveness",
  ],
  "Paroxysmal\u00a0dyspnea": [
    "Orthopnea",
    "Shortness of breath",
    "Dyspnea on exertion",
    "Jugular venous distention",
    "Rale",
    "Pain chest",
    "Palpitation",
    "Sweat",
    "Sweating increased",
    "Weight gain",
    "Cough",
    "Dyspnea",
  ],
  Hernia: [
    "Pain abdominal",
    "Pain",
    "Hyperventilation",
    "Excruciating pain",
    "Gag",
    "Nausea",
    "Posturing",
    "Hemiplegia",
    "Sore to touch",
    "Haemorrhage",
    "Apyrexial",
    "Food intolerance",
    "Pulse absent",
    "Asthenia",
    "Mass of body structure",
    "Thicken",
  ],
  "Malignant neoplasm of prostate": [
    "Hematuria",
    "Dysesthesia",
    "Asthenia",
    "Polymyalgia",
    "Passed stones",
    "Pleuritic pain",
    "Guaiac positive",
    "Rale",
    "Breath sounds decreased",
    "Urge incontinence",
    "Dysuria",
    "Diarrhea",
    "Vertigo",
    "Qt interval prolonged",
    "Ataxia",
    "Paresis",
    "Hemianopsia homonymous",
    "Tumor cell invasion",
    "Hemodynamically stable",
    "Mass of body structure",
    "Rhonchus",
    "Orthostasis",
    "Decreased body weight",
  ],
  "Carcinoma prostate": [
    "Hematuria",
    "Dysesthesia",
    "Asthenia",
    "Polymyalgia",
    "Passed stones",
    "Pleuritic pain",
    "Guaiac positive",
    "Rale",
    "Breath sounds decreased",
    "Urge incontinence",
    "Dysuria",
    "Diarrhea",
    "Vertigo",
    "Qt interval prolonged",
    "Ataxia",
    "Paresis",
    "Hemianopsia homonymous",
    "Tumor cell invasion",
    "Hemodynamically stable",
    "Mass of body structure",
    "Rhonchus",
    "Orthostasis",
    "Decreased body weight",
  ],
  "Edema pulmonary": [
    "Urgency of\u00a0micturition",
    "Shortness of breath",
    "Rale",
    "Tachypnea",
    "Orthopnea",
    "Heberden's node",
    "Jugular venous distention",
    "Dyspnea",
    "Sweat",
    "Sweating increased",
    "Patient non compliance",
    "Chest discomfort",
    "Hyperkalemia",
    "Sinus rhythm",
    "Pain chest",
    "Hypotension",
    "Wheezing",
  ],
  "Lymphatic diseases": [
    "Pain",
    "Mass of body structure",
    "Night sweat",
    "Splenomegaly",
    "Lesion",
    "Chill",
    "Decreased body weight",
    "Swelling",
    "Fever",
    "Hyperacusis",
    "Fremitus",
    "Non-productive cough",
    "Egophony",
    "Redness",
    "Hepatomegaly",
    "Fatigue",
  ],
  "Stenosis aortic valve": [
    "Dyspnea on exertion",
    "Syncope",
    "Chest discomfort",
    "Systolic murmur",
    "Sciatica",
    "Angina pectoris",
    "Pain chest",
    "Frothy sputum",
    "Bradycardia",
    "Shortness of breath",
    "Pain",
  ],
  "Malignant neoplasm of breast": [
    "Mass in breast",
    "Mass of body structure",
    "Paresthesia",
    "Retropulsion",
    "Erythema",
    "Difficulty",
    "Lesion",
    "Estrogen use",
    "Burning sensation",
    "Dyspnea",
    "Swelling",
    "Formication",
  ],
  "Carcinoma breast": [
    "Mass in breast",
    "Mass of body structure",
    "Paresthesia",
    "Retropulsion",
    "Erythema",
    "Difficulty",
    "Lesion",
    "Estrogen use",
    "Burning sensation",
    "Dyspnea",
    "Swelling",
    "Formication",
  ],
  Schizophrenia: [
    "Hallucinations auditory",
    "Hypersomnolence",
    "Irritable mood",
    "Verbal auditory hallucinations",
    "Patient non compliance",
    "Agitation",
    "Suicidal",
    "Worry",
    "Hallucinations visual",
    "Underweight",
    "Underweight",
    "Homelessness",
  ],
  Diverticulitis: [
    "Pain abdominal",
    "Abscess bacterial",
    "Dullness",
    "Red blotches",
    "Diarrhea",
    "Sore to touch",
    "Dysuria",
    "Pain",
    "Vomiting",
    "Sinus rhythm",
    "Colic abdominal",
    "Apyrexial",
    "Abdominal tenderness",
    "Fever",
    "Unsteady gait",
    "Thicken",
    "Urgency of\u00a0micturition",
    "Anorexia",
    "Monoclonal",
    "Constipation",
  ],
  "Overload fluid": [
    "Rale",
    "Jugular venous distention",
    "Hyperkalemia",
    "Orthopnea",
    "Shortness of breath",
    "Drowsiness",
    "Sleepy",
    "Weight gain",
    "Hypokalemia",
    "Hypotension",
    "Swelling",
    "Distended abdomen",
  ],
  "Ulcer peptic": ["Pain abdominal", "Paraparesis", "Nausea", "Vomiting", "Polymyalgia", "Out of breath", "Pain chest", "Hemiplegia", "Gurgle", "Hunger", "Apyrexial", "Nervousness"],
  Osteomyelitis: [
    "Pain",
    "Redness",
    "Prostate tender",
    "Fever",
    "Difficulty passing urine",
    "Sore to touch",
    "Swelling",
    "Apyrexial",
    "Erythema",
    "Abscess bacterial",
    "Pain foot",
    "Urinary hesitation",
  ],
  Gastritis: [
    "Heme positive",
    "Pain abdominal",
    "Vomiting",
    "Disequilibrium",
    "Nausea",
    "Intoxication",
    "Haemorrhage",
    "Guaiac positive",
    "Pain",
    "Decreased body weight",
    "Sore to touch",
    "Dizziness",
  ],
  Bacteremia: [
    "Fever",
    "Chill",
    "Flushing",
    "Unresponsiveness",
    "Indifferent mood",
    "Urinoma",
    "Vomiting",
    "Distended abdomen",
    "Hypoalbuminemia",
    "Pustule",
    "Prostatism",
    "Diarrhea",
    "Abdominal tenderness",
    "Pleuritic pain",
    "Decreased translucency",
    "Pallor",
  ],
  "Failure kidney": [
    "Orthopnea",
    "Oliguria",
    "Slowing of urinary stream",
    "Extreme exhaustion",
    "Unresponsiveness",
    "Hypotension",
    "Enuresis",
    "Shortness of breath",
    "Haemorrhage",
    "Prostatism",
    "No status change",
    "Bedridden",
    "Bedridden",
    "Fatigue",
  ],
  "Sickle cell anemia": ["Breakthrough pain", "Pain back", "Pain", "Shortness of breath", "Snuffle", "Pain chest", "Pain abdominal", "Hepatosplenomegaly", "Green sputum", "Apyrexial", "Headache"],
  "Failure heart": [
    "Orthopnea",
    "Fatigue",
    "Dyspnea on exertion",
    "Dyspnea",
    "Shortness of breath",
    "Pansystolic murmur",
    "Jugular venous distention",
    "Systolic ejection murmur",
    "Hypotension",
    "Angina pectoris",
    "Hypokinesia",
  ],
  "Upper respiratory infection": [
    "Cough",
    "Throat sore",
    "Wheezing",
    "Shortness of breath",
    "Labored breathing",
    "Fever",
    "Stuffy nose",
    "Non-productive cough",
    "Snuffle",
    "Indifferent mood",
    "Egophony",
    "Barking cough",
    "Polymyalgia",
    "Pleuritic pain",
    "Night sweat",
    "Dyspnea",
    "Productive cough",
    "Decreased translucency",
    "Rhonchus",
    "Rapid shallow breathing",
    "Apyrexial",
    "Noisy respiration",
    "Nasal discharge present",
    "Emphysematous change",
    "Frail",
    "Cystic lesion",
    "Symptom aggravating factors",
    "Hemodynamically stable",
  ],
  Hepatitis: [
    "Ascites",
    "Spontaneous rupture of membranes",
    "Tachypnea",
    "Pain abdominal",
    "Pruritus",
    "Anorexia",
    "Transaminitis",
    "Projectile vomiting",
    "Chill",
    "Distress respiratory",
    "Fever",
    "Vomiting",
  ],
  "Hypertension pulmonary": [
    "Shortness of breath",
    "Stahli's line",
    "Heavy legs",
    "Breath sounds decreased",
    "Neck stiffness",
    "Dyspnea on exertion",
    "Cyanosis",
    "Hypotension",
    "Left\u00a0atrial\u00a0hypertrophy",
  ],
  "Deglutition disorder": [
    "Paresthesia",
    "Titubation",
    "Dysarthria",
    "Painful swallowing",
    "Hoarseness",
    "Stridor",
    "Spasm",
    "Asthenia",
    "Dysdiadochokinesia",
    "Ataxia",
    "Achalasia",
    "Decreased body weight",
    "Stiffness",
    "Lesion",
    "Side pain",
  ],
  Gout: ["Hot flush", "Pain", "Redness", "Swelling", "Erythema", "Emphysematous change", "Sore to touch", "Hypokinesia", "Ascites", "Patient non compliance"],
  Thrombocytopaenia: ["Ecchymosis", "Monocytosis", "Posterior\u00a0rhinorrhea", "Haemorrhage", "Tachypnea", "Fever", "Pruritus", "Hypotension", "Fatigue"],
  Hypoglycemia: [
    "Unresponsiveness",
    "Hypothermia, natural",
    "Incoherent",
    "Qt interval prolonged",
    "Lameness",
    "Claudication",
    "Unconscious state",
    "Clammy skin",
    "Polyuria",
    "Distress respiratory",
    "Hypotension",
  ],
  "Pneumonia aspiration": [
    "Mediastinal shift",
    "Fever",
    "Clonus",
    "Mental status changes",
    "Decreased translucency",
    "Unresponsiveness",
    "Extreme exhaustion",
    "Stupor",
    "Seizure",
    "Transaminitis",
    "Hemiplegia",
    "Cough",
    "Gurgle",
    "Pain",
    "Diarrhea",
    "Pain abdominal",
  ],
  Colitis: [
    "Fever",
    "Thicken",
    "Green sputum",
    "Vomiting",
    "Nausea and vomiting",
    "Awakening early",
    "Pain",
    "Nausea",
    "Chill",
    "Tenesmus",
    "Urge incontinence",
    "Pain abdominal",
    "Hemodynamically stable",
  ],
  Diverticulosis: [
    "Fecaluria",
    "Constipation",
    "Abscess bacterial",
    "Heme positive",
    "Lightheadedness",
    "Diarrhea",
    "Haemorrhage",
    "Pain",
    "Projectile vomiting",
    "Pneumatouria",
    "Cystic lesion",
    "Anorexia",
    "Nausea",
    "Feeling suicidal",
    "Feeling hopeless",
  ],
  "Suicide attempt": [
    "Hallucinations auditory",
    "Sleeplessness",
    "Suicidal",
    "Motor retardation",
    "Weepiness",
    "Unable to concentrate",
    "Todd paralysis",
    "Worry",
    "Fatigue",
    "Tremor",
    "Alcoholic withdrawal symptoms",
    "Agitation",
    "Unresponsiveness",
    "Blackout",
    "Withdraw",
    "Difficulty",
    "Irritable mood",
    "Sensory discomfort",
    "Drowsiness",
    "Formication",
    "Unconscious state",
    "Fever",
    "Cough",
  ],
  "Pneumocystis\u00a0carinii\u00a0pneumonia": [
    "Yellow sputum",
    "Cachexia",
    "Chill",
    "Decreased body weight",
    "Productive cough",
    "Myalgia",
    "Diarrhea",
    "Neck stiffness",
    "Hacking cough",
    "Dyspareunia",
    "Hypokalemia",
    "Dyspnea on exertion",
    "Poor dentition",
    "Transaminitis",
    "Non-productive cough",
    "Headache",
    "Floppy",
    "Spontaneous rupture of membranes",
  ],
  "Hepatitis b": ["Inappropriate affect", "Tachypnea", "Yellow sputum", "Projectile vomiting", "Poor feeding", "Pain abdominal", "Abdominal tenderness", "Wheelchair bound", "Moan"],
  "Parkinson disease": [
    "Achalasia",
    "Fall",
    "Stiffness",
    "Withdraw",
    "Agitation",
    "Hemiplegia",
    "Difficulty",
    "Unresponsiveness",
    "Syncope",
    "Facial paresis",
    "Orthostasis",
    "Worry",
    "Drowsiness",
    "Sleepy",
    "Hematuria",
    "Tremor",
    "Night sweat",
    "Mass of body structure",
  ],
  Lymphoma: [
    "Lesion",
    "Fever",
    "Welt",
    "Transaminitis",
    "Decreased body weight",
    "Ataxia",
    "Tinnitus",
    "Hydropneumothorax",
    "Superimposition",
    "Haemoptysis",
    "Fatigue",
    "Polydypsia",
    "Difficulty passing urine",
  ],
  Hyperglycemia: [
    "Sore to touch",
    "Pruritus",
    "Feeling strange",
    "Pustule",
    "Cushingoid facies",
    "Cushingoid\u00a0habitus",
    "Decreased body weight",
    "Mood depressed",
    "Estrogen use",
    "Wheezing",
    "Ascites",
    "Seizure",
  ],
  Encephalopathy: [
    "Uncoordination",
    "Asterixis",
    "Haemorrhage",
    "Drowsiness",
    "Sleepy",
    "Absences finding",
    "Posturing",
    "Aura",
    "Tonic seizures",
    "Debilitation",
    "Consciousness clear",
    "Unresponsiveness",
    "Thicken",
    "Hypokinesia",
  ],
  "Tricuspid valve insufficiency": ["Shortness of breath", "Pain", "Vomiting", "Nausea", "Bradycardia", "Pain abdominal", "Fever", "Cicatrisation", "Mediastinal shift", "Impaired cognition"],
  "Alzheimer's disease": [
    "Drool",
    "Agitation",
    "Nightmare",
    "Rhonchus",
    "Consciousness clear",
    "Pin-point pupils",
    "Bedridden",
    "Bedridden",
    "Frail",
    "Tremor resting",
    "Hyperkalemia",
    "Facial paresis",
    "Groggy",
    "Muscle twitch",
    "Wheelchair bound",
    "Tremor",
    "Cough",
    "Fever",
  ],
  Candidiasis: [
    "Diarrhea",
    "Throat sore",
    "Decreased body weight",
    "Chill",
    "Headache",
    "Abdominal tenderness",
    "Patient non compliance",
    "Photophobia",
    "Night sweat",
    "Painful swallowing",
    "Poor dentition",
    "Transaminitis",
    "Non-productive cough",
    "Adverse reaction",
    "Adverse effect",
    "Abdominal bloating",
  ],
  Oralcandidiasis: [
    "Diarrhea",
    "Throat sore",
    "Decreased body weight",
    "Chill",
    "Headache",
    "Abdominal tenderness",
    "Patient non compliance",
    "Photophobia",
    "Night sweat",
    "Painful swallowing",
    "Poor dentition",
    "Transaminitis",
    "Non-productive cough",
    "Adverse reaction",
    "Adverse effect",
    "Abdominal bloating",
  ],
  Neuropathy: ["Asthenia", "Numbness", "Nausea and vomiting", "Awakening early", "Hydropneumothorax", "Superimposition", "Fatigability", "Tenesmus", "Pain", "Slowing of urinary stream"],
  "Kidney disease": ["Shortness of breath", "Hyperkalemia", "Pain chest", "Fever", "Gravida 0", "Bleeding of vagina"],
  "Fibroid tumor": [
    "Haemorrhage",
    "Intermenstrual heavy bleeding",
    "Muscle hypotonia",
    "Hypotonic",
    "Previous pregnancies 2",
    "Shortness of breath",
    "Fever",
    "Heartburn",
    "Primigravida",
    "Abnormally hard consistency",
    "Proteinemia",
  ],
  Glaucoma: ["Fall", "Distended abdomen", "Unsteady gait", "Paresthesia", "Hyponatremia", "Agitation", "Unconscious state", "Burning sensation", "Lesion", "Mass of body structure"],
  "Neoplasm metastasis": ["Thicken", "Tumor cell invasion", "Metastatic lesion", "Pain neck", "Lung nodule", "Pain", "Pain abdominal", "Food intolerance", "Mass of body structure", "Atypia"],
  "Malignant tumor of colon": [
    "Lesion",
    "Prostatism",
    "Constipation",
    "General discomfort",
    "Diarrhea",
    "Pain abdominal",
    "Urinary hesitation",
    "Dizzy spells",
    "Shooting pain",
    "Bradycardia",
    "Vomiting",
    "Systolic ejection murmur",
    "Nausea",
    "Hyperemesis",
    "Polydypsia",
  ],
  "Carcinoma colon": [
    "Lesion",
    "Prostatism",
    "Constipation",
    "General discomfort",
    "Diarrhea",
    "Pain abdominal",
    "Urinary hesitation",
    "Dizzy spells",
    "Shooting pain",
    "Bradycardia",
    "Vomiting",
    "Systolic ejection murmur",
    "Nausea",
    "Hyperemesis",
    "Polydypsia",
  ],
  "Ketoacidosis diabetic": [
    "Polyuria",
    "Vomiting",
    "Nausea",
    "Pain abdominal",
    "Milky",
    "Feeling strange",
    "Gurgle",
    "Nervousness",
    "Abdominal tenderness",
    "Regurgitates after swallowing",
    "Vision blurred",
    "Urinary hesitation",
    "Diarrhea",
    "Seizure",
    "Aura",
  ],
  "Tonic-clonic epilepsy": [
    "Drowsiness",
    "Lip smacking",
    "Myoclonus",
    "Tremor",
    "Phonophobia",
    "Rolling of eyes",
    "Sleepy",
    "Hirsutism",
    "Moody",
    "Muscle twitch",
    "Unresponsiveness",
    "Headache",
    "Ambidexterity",
    "Absences finding",
    "Spasm",
    "Decreased body weight",
    "Tumor cell invasion",
  ],
  "Tonic-clonic seizures": [
    "Drowsiness",
    "Lip smacking",
    "Myoclonus",
    "Tremor",
    "Phonophobia",
    "Rolling of eyes",
    "Sleepy",
    "Hirsutism",
    "Moody",
    "Muscle twitch",
    "Unresponsiveness",
    "Headache",
    "Ambidexterity",
    "Absences finding",
    "Spasm",
    "Decreased body weight",
    "Tumor cell invasion",
  ],
  "Malignant\u00a0neoplasms": [
    "Pulsus\u00a0paradoxus",
    "Gravida 10",
    "Mass of body structure",
    "Lesion",
    "Heartburn",
    "Night sweat",
    "Thicken",
    "Chill",
    "Decreased translucency",
    "Pain abdominal",
    "Dullness",
    "Food intolerance",
    "Distress respiratory",
    "Hypotension",
  ],
  "Respiratory failure": [
    "Hemiplegia",
    "Snore",
    "Unresponsiveness",
    "Productive cough",
    "Dyspnea",
    "Tachypnea",
    "Hyperkalemia",
    "Hypokinesia",
    "Sinus rhythm",
    "General unsteadiness",
    "Bruit",
    "Consciousness clear",
    "Shortness of breath",
    "Lesion",
    "Redness",
  ],
  Melanoma: ["Mass of body structure", "Paraparesis", "Fever", "Gravida 0", "Pain", "Pruritus", "Mass in breast", "Vomiting", "Diarrhea"],
  Gastroenteritis: [
    "Pain abdominal",
    "Breath-holding spell",
    "Nausea",
    "Decreased body weight",
    "Sore to touch",
    "Scleral\u00a0icterus",
    "Fever",
    "Myalgia",
    "Hyponatremia",
    "Retch",
    "Mass of body structure",
    "Decreased body weight",
  ],
  "Malignant neoplasm of lung": [
    "Lesion",
    "Cough",
    "Lung nodule",
    "Shortness of breath",
    "Haemoptysis",
    "Debilitation",
    "Gurgle",
    "Ache",
    "Rale",
    "Night sweat",
    "Decreased translucency",
    "Asthenia",
    "Metastatic lesion",
    "Agitation",
    "Irritable mood",
  ],
  "Carcinoma of lung": [
    "Lesion",
    "Cough",
    "Lung nodule",
    "Shortness of breath",
    "Haemoptysis",
    "Debilitation",
    "Gurgle",
    "Ache",
    "Rale",
    "Night sweat",
    "Decreased translucency",
    "Asthenia",
    "Metastatic lesion",
    "Agitation",
    "Irritable mood",
  ],
  "Manic disorder": [
    "Energy increased",
    "Suicidal",
    "Hypersomnia",
    "Feeling suicidal",
    "Blanch",
    "Hallucinations auditory",
    "Hallucinations visual",
    "Elation",
    "Verbal auditory hallucinations",
    "Feeling hopeless",
    "Difficulty",
    "Decompensation",
    "Verbally abusive behavior",
    "Suicidal",
    "Feeling suicidal",
  ],
  "Personality disorder": [
    "Nightmare",
    "Feeling hopeless",
    "Transsexual",
    "Hallucinations auditory",
    "Irritable mood",
    "Sleeplessness",
    "Agitation",
    "Weepiness",
    "Mood depressed",
    "Scratch marks",
    "Nausea and vomiting",
    "Extreme exhaustion",
    "Side pain",
    "Worry",
    "Enuresis",
    "Homelessness",
    "Nervousness",
    "Ascites",
    "Pruritus",
  ],
  "Primary carcinoma of the liver cells": [
    "Mass of body structure",
    "Splenomegaly",
    "Lesion",
    "Paresis",
    "Tumor cell invasion",
    "Room spinning",
    "Haemorrhage",
    "Thicken",
    "Indifferent mood",
    "Cachexia",
    "Hypothermia, natural",
    "Pain abdominal",
    "Hepatomegaly",
    "Hematocrit decreased",
    "Stupor",
    "Decreased body weight",
    "Shortness of breath",
    "Cough",
  ],
  "Emphysema pulmonary": [
    "Behavior showing increased motor activity",
    "Scar tissue",
    "Dyspnea on exertion",
    "Coordination abnormal",
    "Myalgia",
    "Hypercapnia",
    "Clammy skin",
    "Has religious belief",
    "Room spinning",
    "Moan",
    "Night sweat",
    "Cachexia",
    "Symptom aggravating factors",
    "Dyspnea",
    "Rale",
    "Flushing",
    "Painful swallowing",
    "Arthralgia",
    "Choke",
    "Tenesmus",
    "Constipation",
  ],
  Hemorrhoids: [
    "Haemorrhage",
    "Bowel sounds decreased",
    "Decreased stool caliber",
    "Nausea and vomiting",
    "Hunger",
    "Diarrhea",
    "Dizziness",
    "Hyponatremia",
    "Clonus",
    "Pain",
    "Achalasia",
    "Burning sensation",
    "Guaiac positive",
    "Numbness of hand",
    "Wheezing",
    "Cough",
  ],
  "Spasm bronchial": [
    "Shortness of breath",
    "Scar tissue",
    "Apyrexial",
    "No known drug allergies",
    "Pain",
    "Productive cough",
    "Throat sore",
    "Dyspnea",
    "Chest tightness",
    "Hypoxemia",
    "Tachypnea",
    "Sensory discomfort",
    "Fever",
    "Vomiting",
    "Rhonchus",
    "Hemiplegia",
    "Fremitus",
  ],
  Aphasia: ["Clonus", "Egophony", "Facial paresis", "Aphagia", "Muscle twitch", "Paralyse", "Low back pain", "Charleyhorse"],
  "Obesity morbid": [
    "Out of breath",
    "Sedentary",
    "Angina pectoris",
    "Cough",
    "Unhappy",
    "Labored breathing",
    "Hypothermia, natural",
    "Dyspnea",
    "Hematocrit decreased",
    "Wheezing",
    "Hypoxemia",
    "Renal angle tenderness",
    "Feels hot/feverish",
  ],
  Pyelonephritis: ["Fever", "Pain", "Urgency of\u00a0micturition", "Hematuria", "Vomiting", "Chill", "Diarrhea", "Nausea", "Pain abdominal", "Myalgia", "Fever", "Chill"],
  Endocarditis: [
    "Pleuritic pain",
    "Thicken",
    "Myalgia",
    "Apyrexial",
    "Night sweat",
    "Flare",
    "Shortness of breath",
    "Orthopnea",
    "Abscess bacterial",
    "Hypotension",
    "Cough",
    "Metastatic lesion",
    "Breath sounds decreased",
    "Decreased body weight",
    "Decreased body weight",
    "Pulsus\u00a0paradoxus",
    "Hypokinesia",
  ],
  "Effusion pericardial": [
    "Pericardial friction rub",
    "Dyspnea",
    "Shortness of breath",
    "Hemodynamically stable",
    "Cardiomegaly",
    "Hypotension",
    "Sputum purulent",
    "Facial paresis",
    "Pain",
    "Oliguria",
    "Blackout",
    "Intoxication",
  ],
  "Pericardial effusion body substance": [
    "Pericardial friction rub",
    "Dyspnea",
    "Shortness of breath",
    "Hemodynamically stable",
    "Cardiomegaly",
    "Hypotension",
    "Sputum purulent",
    "Facial paresis",
    "Pain",
    "Oliguria",
    "Blackout",
    "Intoxication",
  ],
  "Chronic alcoholic intoxication": [
    "Tremor",
    "Hallucinations auditory",
    "Suicidal",
    "Hoard",
    "Irritable mood",
    "Feeling hopeless",
    "Feeling suicidal",
    "Neologism",
    "Seizure",
    "Homelessness",
    "Sleeplessness",
    "Unconscious state",
    "Panic",
    "Breath sounds decreased",
    "Shortness of breath",
  ],
  Pneumothorax: ["Dyspnea", "Cardiovascular finding", "Cardiovascular event", "Haemoptysis", "Cough", "Hypercapnia", "Soft tissue swelling", "Prostatism", "Agitation"],
  Delirium: [
    "Unsteady gait",
    "Withdraw",
    "Hyponatremia",
    "Verbally abusive behavior",
    "Feeling suicidal",
    "Unresponsiveness",
    "Worry",
    "Drowsiness",
    "Sleepy",
    "Hallucinations auditory",
    "Suicidal",
    "Fever",
    "Diarrhea",
  ],
  Neutropenia: [
    "Transaminitis",
    "Splenomegaly",
    "Night sweat",
    "Apyrexial",
    "Lesion",
    "Snuffle",
    "Chill",
    "Cough",
    "Monoclonal",
    "Hypocalcemia result",
    "Oliguria",
    "Rhd positive",
    "Distress respiratory",
  ],
  Hyperbilirubinemia: ["Cyanosis", "Tachypnea", "Bradycardia", "Breech presentation", "Cushingoid facies", "Cushingoid\u00a0habitus", "Cough", "Myalgia"],
  Influenza: [
    "Uncoordination",
    "Fever",
    "Pleuritic pain",
    "Snuffle",
    "Throat sore",
    "Malaise",
    "Debilitation",
    "Symptom aggravating factors",
    "Chill",
    "Scleral\u00a0icterus",
    "Nasal flaring",
    "Dysuria",
    "Lip smacking",
    "Headache",
    "Sneeze",
    "Snore",
    "Green sputum",
    "Shortness of breath",
    "Distress respiratory",
    "Blackout",
    "Extreme exhaustion",
  ],
  Dependence: ["Intoxication", "Tremor", "Agitation", "Suicidal", "Homelessness", "Prostatism", "Lethargy", "Seizure", "Muscle twitch", "Stuffy nose", "Feeling hopeless", "Heavy legs", "Rale"],
  Thrombus: [
    "Hypokinesia",
    "Anorexia",
    "Hypertonicity",
    "Shortness of breath",
    "Hypoalbuminemia",
    "Pruritus",
    "Sore to touch",
    "Hemodynamically stable",
    "Facial paresis",
    "Vomiting",
    "Stool color yellow",
  ],
  Cholecystitis: [
    "Moan",
    "Nausea",
    "Pain abdominal",
    "Murphy's sign",
    "Flatulence",
    "Colic abdominal",
    "Pain",
    "Ascites",
    "Diarrhea",
    "Qt interval prolonged",
    "Cardiovascular finding",
    "Cardiovascular event",
    "Groggy",
    "Sinus rhythm",
    "Gasping for breath",
    "Constipation",
    "Feces in rectum",
    "Abnormally hard consistency",
  ],
  "Hernia\u00a0hiatal": [
    "Pain abdominal",
    "Fatigability",
    "Prodrome",
    "Vomiting",
    "Nausea",
    "Myalgia",
    "Hyponatremia",
    "Sore to touch",
    "General discomfort",
    "Dyspnea on exertion",
    "Asterixis",
    "Guaiac positive",
    "Numbness of hand",
    "Headache",
    "Photophobia",
  ],
  "Migraine disorders": ["Ambidexterity", "Vomiting", "Dizziness", "Numbness", "Nausea", "Fever", "Splenomegaly"],
  Pancytopenia: ["Hypoproteinemia", "Fatigue", "Haemorrhage", "Fatigability", "Cushingoid facies", "Cushingoid\u00a0habitus", "Stool color yellow", "Colic abdominal"],
  Cholelithiasis: ["Vomiting", "Nausea", "Pain abdominal", "Pain", "Cushingoid facies", "Cushingoid\u00a0habitus", "Ascites", "Thicken", "Sore to touch", "Diarrhea", "Apyrexial", "Palpitation"],
  "Biliary calculus": ["Vomiting", "Nausea", "Pain abdominal", "Pain", "Cushingoid facies", "Cushingoid\u00a0habitus", "Ascites", "Thicken", "Sore to touch", "Diarrhea", "Apyrexial", "Palpitation"],
  "Tachycardia sinus": [
    "Left\u00a0atrial\u00a0hypertrophy",
    "Sweat",
    "Sweating increased",
    "Alcohol binge episode",
    "Pressure chest",
    "Scar tissue",
    "Cardiovascular finding",
    "Cardiovascular event",
    "Orthostasis",
    "Shortness of breath",
    "T wave inverted",
    "Vomiting",
    "Pain abdominal",
  ],
  Ileus: [
    "Abscess bacterial",
    "Abdomen acute",
    "Air fluid level",
    "Catching breath",
    "Abdominal tenderness",
    "Nausea",
    "Sore to touch",
    "Flatulence",
    "Diarrhea",
    "Mass of body structure",
    "Apyrexial",
    "Constipation",
    "Thicken",
    "Gravida 0",
    "Pain abdominal",
  ],
  Adhesion: [
    "Flatulence",
    "Pain",
    "Large-for-dates fetus",
    "Vomiting",
    "Lung nodule",
    "Breech presentation",
    "Shortness of breath",
    "Decreased body weight",
    "Immobile",
    "Unsteady gait",
    "Hallucinations visual",
    "Feeling suicidal",
  ],
  Delusion: [
    "Loose associations",
    "Giddy mood",
    "Feeling hopeless",
    "Agitation",
    "Hallucinations auditory",
    "Irritable mood",
    "Sleeplessness",
    "Neologism",
    "Homicidal thoughts",
    "Disturbed family",
    "Worry",
    "Decompensation",
    "Verbally abusive behavior",
    "Catatonia",
    "Suicidal",
    "Terrify",
    "Blackout",
    "Weepiness",
    "Impaired cognition",
    "Irritable mood",
    "Agitation",
  ],
  "Affect labile": ["Extreme exhaustion", "Sleeplessness", "Enuresis", "Patient non compliance", "Feeling hopeless", "Hallucinations visual", "Bedridden", "Bedridden", "Prostatism"],
  "Decubitus ulcer": ["Systolic murmur", "Frail", "Fever"],
};
